import { CustomModal, Header } from "./styles";
import useModal from "../../hooks/useModal";
import { FaEye } from "react-icons/fa";
import { Button } from "antd";
import { useGetJobsByGroup } from "../../hooks/useGetJobs";
import DatatableAntd from "components/datatable-antd";
import columns from "./columns";

export default function ViewJobsModal() {
  const { isViewingJobs, setIsViewingJobs, id } = useModal();

  const { data: jobs, isLoading: isLoadingJobs } = useGetJobsByGroup({
    groupId: id ?? "",
  });

  return (
    <CustomModal
      visible={isViewingJobs}
      onCancel={() => setIsViewingJobs(false)}
      maskClosable={false}
      footer={
        <>
          <Button
            type="primary"
            onClick={() => setIsViewingJobs(false)}
            style={{ borderRadius: 8 }}
            size="large"
          >
            Fechar
          </Button>
        </>
      }
      width={1300}
      title={
        <Header>
          <FaEye size={18} />
          Visualizar Grupo de Jobs
        </Header>
      }
    >
      <h2 style={{ marginBottom: 16, fontSize: 16 }}>
        Total de Jobs Vinculados:{" "}
        <b>{isLoadingJobs ? "Carregando..." : jobs?.jobs?.length}</b>
      </h2>

      <DatatableAntd
        loading={isLoadingJobs}
        dataSource={jobs?.jobs}
        columns={columns}
        maxH="443"
        overflow="auto"
      />
    </CustomModal>
  );
}
